   <app-events
    [events]="events"
    [expanded]="expanded"
    [isSticky]="true"
    (expand)="expanded = true"
    [language]="project.language"
  >
  </app-events>